export default "__VITE_ASSET__49767264__"